import React from 'react';
import { ShellOverlay, ShellContainer, ShellHeader, ShellTitle, ShellCloseBtn } from './ModalShell.styles';

const XIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" />
  </svg>
);

const ModalShell = ({ title, onClose, maxWidth, children }) => (
  <ShellOverlay onClick={onClose}>
    <ShellContainer $maxWidth={maxWidth} onClick={(e) => e.stopPropagation()}>
      <ShellHeader>
        <ShellTitle>{title}</ShellTitle>
        <ShellCloseBtn type="button" onClick={onClose} aria-label="Close">
          <XIcon />
        </ShellCloseBtn>
      </ShellHeader>
      {children}
    </ShellContainer>
  </ShellOverlay>
);

export default ModalShell;
